/**
 * THE client mirror of the server's `OVERRIDE_REASON_MAX`
 * (`server/helpers/overrideReason.js`) — the cap on a caller-typed reason for
 * bypassing an approval control.
 *
 * A CONVENIENCE, NEVER THE GATE: every server door refuses an over-long
 * reason with a 400 and writes nothing. It exists so a textarea can never
 * SEND one.
 *
 * Moved here 2026-09-14 from `constants/postApprovalEdit.js` (which now
 * re-exports it as its named sibling `EDIT_REASON_MAX`, exactly as the server's
 * `helpers/orderEditDiff.js` does) when approve-on-behalf became the second
 * client dialog to need it — a module name about post-approval EDITS was the
 * wrong home for a number an approval dialog imports. One literal, never a
 * second `2000`.
 */
export const OVERRIDE_REASON_MAX = 2000;
